import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#31493C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.3}
      d="M8.668 18.5h17.5"
    />
    <path
      stroke="#31493C"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.3}
      d="m9.5 18.5.044-10.526c0-.534.253-1.041.673-1.374l6.126-4.769a1.76 1.76 0 0 1 2.152 0l6.125 4.76c.429.333.674.84.674 1.383V18.5"
    />
    <path
      fill="#fff"
      d="m3.371 20.25.044-10.526c0-.534.254-1.041.674-1.374l6.125-4.769a1.76 1.76 0 0 1 2.152 0l6.125 4.76c.429.333.674.84.674 1.383V20.25"
    />
    <path
      stroke="#31493C"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.3}
      d="m3.371 20.25.044-10.526c0-.534.254-1.041.674-1.374l6.125-4.769a1.76 1.76 0 0 1 2.152 0l6.125 4.76c.429.333.674.84.674 1.383V20.25"
    />
    <path
      stroke="#31493C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.3}
      d="M2.543 20.25h17.5M14.355 10.625H8.23a1.31 1.31 0 0 0-1.312 1.313v8.312h8.75v-8.312a1.31 1.31 0 0 0-1.313-1.313ZM9.543 15.219v1.312M9.98 7.563h2.625"
    />
  </svg>
);
export default SvgComponent;
